import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import styles from "./SubmitButton.css";

const { t } = new Translate("SubmitButton");

const SubmitButton = (props) => {
  const { isDanger, isDisabled, isSubmitting, onSubmit, submitLabel, submittingLabel } = props;

  return (
    <button
      className={classnames(styles.root, {
        [styles.disabled]: isSubmitting || isDisabled,
        [styles.red]: isDanger,
      })}
      onClick={() => (isSubmitting || isDisabled || !onSubmit ? null : onSubmit())}
      type="submit"
    >
      {isSubmitting ? submittingLabel : submitLabel}
    </button>
  );
};

SubmitButton.propTypes = {
  submitLabel: PropTypes.string,
  submittingLabel: PropTypes.string,
  onSubmit: PropTypes.func,
  isDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isDanger: PropTypes.bool,
};

SubmitButton.defaultProps = {
  submitLabel: t("submit"),
  submittingLabel: t("submitting"),
  isDisabled: false,
};

export default SubmitButton;
